import React, { useContext, useState } from 'react'
import '../../PopUp/PopUP.css'
import ViewSummaryWeekly from '../../day-event/View-summaryWeekly';
import { NavLink, useNavigate } from 'react-router-dom';
import { SubStdSelContext } from '../../../../SubStdSelContext';
import { connect } from 'react-redux';
import { useLocation } from 'react-router-dom';


const mapStateToProps = (state) => (
    {
        inc: state.redres,
        dec: state.redres1,
        ovr: state.redres2,
    });
function ViewSummaryBtn({ event, refresh, inc, dec, assessment }) {
    const [summary1, setSummary1] = useState(false);
    const navigate = useNavigate();
    const { secSelectedOption, stdSelectedOption } = useContext(SubStdSelContext);
    const standardsName = localStorage.getItem('stdSelectionName')
    const sectionName = localStorage.getItem('secSelectionName')
    return (
        <>
            {event?.Subject !== "Assembly" && <div>
                <div id="card_body_new">
                    {
                        // Here I checked the condition for event?.Supplement_id present on not
                        event?.Supplement_id ? <NavLink
                            className="link"
                            to={`/liveSession`}
                            state={{ supplement_id: event.Supplement_id, standard_id: stdSelectedOption, section_id: secSelectedOption, lecture_id: event.Id, scheduled_date: event.StartTime, standardsName: standardsName, sectionName: sectionName }}
                        >
                            <div id="card_body_new" onClick={() => {
                                // set standard_id: inc.id, standardName: inc.name, section_id: dec.id, sectionName: dec.name in localStorage
                                localStorage.setItem("liveSession", JSON.stringify(event));
                                let obj = {
                                    standard_id: inc.id,
                                    section_id: dec.id,
                                }
                                localStorage.setItem("std", JSON.stringify(obj));
                                localStorage.setItem("from", "DCM")
                            }}>
                                {!(event.LactureType === "general_lacture") && <button type="button" id='PopUpBtn' class="btn">View/Edit Summary</button>}
                            </div>
                        </NavLink>
                            : <NavLink
                                className="link"
                                to={`/liveSession`}
                                state={{ supplement_id: event.Supplement_id, standard_id: stdSelectedOption, section_id: secSelectedOption, lecture_id: event.Id, scheduled_date: event.StartTime, standardsName: standardsName, sectionName: sectionName }}
                            >
                                <div id="card_body_new" onClick={() => {
                                    // set standard_id: inc.id, standardName: inc.name, section_id: dec.id, sectionName: dec.name in localStorage
                                    localStorage.setItem("liveSession", JSON.stringify(event));
                                    let obj = {
                                        standard_id: inc.id,
                                        standardName: inc.name,
                                        section_id: dec.id,
                                        sectionName: dec.name
                                    }
                                    localStorage.setItem("std", JSON.stringify(obj));
                                    localStorage.setItem("from", "DCM")
                                }}>
                                    {!(event.LactureType === "general_lacture") && <button type="button" id='PopUpBtn' class="btn">Add Class Material</button>}
                                </div>
                            </NavLink>
                    }

                    {/* <button  type="button" id='PopUpBtn' class="btn" onClick={()=>{window.location.replace(`/ViewSummary/${event?.Supplement_id}`)}}>View Summary</button> */}
                </div>

            </div>}
            {/* {summary1&&<ViewSummaryWeekly event={event} helper={setSummary1} refresh={refresh}/>} */}
        </>
    )
}
export default connect(mapStateToProps)(ViewSummaryBtn)